import { useQuery } from "@tanstack/react-query";

import { ListHouseholdMemberRelationshipsQueryType } from "@/domain/householdMemberRelationship";

import { HouseholdMemberRelationshipsApi } from "../api/householdMemberRelationshipsApi";

export const HouseholdMemberRelationshipsQueryKeys = {
  all: ["householdMemberRelationships"] as const,
  listByPrimaryMember: () =>
    [
      ...HouseholdMemberRelationshipsQueryKeys.all,
      "listByPrimaryMember",
    ] as const,
  listBetweenMembers: (query: ListHouseholdMemberRelationshipsQueryType) =>
    [
      ...HouseholdMemberRelationshipsQueryKeys.all,
      "listBetweenMembers",
      { query },
    ] as const,
};

export const useListHouseholdMemberRelationshipsBetweenMembersQuery = (
  query: ListHouseholdMemberRelationshipsQueryType,
  options?: { enabled?: boolean },
) => {
  const isEnabledByDefault =
    Boolean(query.primaryHouseholdMemberId) &&
    query.relationshipHouseholdMemberIds.length > 0;

  return useQuery({
    queryKey: HouseholdMemberRelationshipsQueryKeys.listBetweenMembers(query),
    queryFn: () =>
      HouseholdMemberRelationshipsApi.listHouseholdMemberRelationshipsBetweenMembers(
        query,
      ),
    enabled: options?.enabled ?? isEnabledByDefault,
  });
};

export const useListHouseholdMemberRelationshipsByPrimaryMemberQuery = ({
  isEnabled = true,
}: {
  isEnabled: boolean;
}) => {
  return useQuery({
    queryKey: HouseholdMemberRelationshipsQueryKeys.listByPrimaryMember(),
    queryFn: async () =>
      HouseholdMemberRelationshipsApi.listHouseholdMemberRelationshipsByPrimaryMember(),
    enabled: isEnabled,
  });
};
